import React, { useState } from "react";

import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import date from "date-and-time";
import moment from "moment";
import Typography from "@material-ui/core/Typography";
import {
  makeStyles,
  ThemeProvider,
  createMuiTheme,
  withStyles,
} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Avatar from "@material-ui/core/Avatar";
import remy from "./1612860349382.jpg";
import clsx from "clsx";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import Kfunc from "../utill/util";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";
// import NumberFormat from "react-number-format";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
// import { LineLogin } from "reactjs-line-login";
// import "reactjs-line-login/dist/index.css";
import { v4 as uuidv4 } from "uuid";
import { Formik, Form } from "formik";
import * as yup from "yup";
import NativeSelect from "@material-ui/core/NativeSelect";
import InputBase from "@material-ui/core/InputBase";
import { useWait, Waiter } from "react-wait";
import "./styles.css";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
// import Avatar from '@material-ui/core/Avatar';
import ImageIcon from "@material-ui/icons/Image";
import WorkIcon from "@material-ui/icons/Work";
import BeachAccessIcon from "@material-ui/icons/BeachAccess";
import Divider from "@material-ui/core/Divider";

const liff = window.liff;
let SignupSchema = yup.object().shape({
  firstName: yup.string().required("This field is required."),
  lastName: yup.string().required("This field is required."),
  email: yup.string().email().required("This field is required."),
  password: yup
    .string()
    .min(6, "Password is too short.")
    .max(20, "Password is too long.")
    .required("This field is required."),
});

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    margin: theme.spacing(3, 0, 2),
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
    margin: {
      margin: theme.spacing(1),
    },
  },
}));

const ValidationTextField = withStyles({
  root: {
    "& input:valid + fieldset": {
      borderColor: "green",
      borderWidth: 2,
    },
    "& input:invalid + fieldset": {
      borderColor: "red",
      borderWidth: 2,
    },
    "& input:valid:focus + fieldset": {
      borderLeftWidth: 6,
      padding: "4px !important", // override inline-style
    },
  },
})(TextField);

const theme = createMuiTheme({
  palette: {
    primary: green,
  },
});
function _interopDefault(ex) {
  return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}
function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[0]/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={"\u2000"}
      showMask
    />
  );
}

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};
export default function Signup() {
  // export const Signup = () => {
  const classes = useStyles();
  /////////////////////////////////BUTON////////////////////////////
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [password, setpassword] = useState("");
  const [paylode, setpaylode] = useState(false);
  const [phone, setphone] = useState(false);
  const [button, setbutton] = useState(true);
  const [Name, setName] = useState(false);
  const [FnameLname, setFnameLname] = useState(false);
  const [brance, setbrance] = useState("");
  const [payload, setPayload] = useState(null);
  const [idToken, setIdToken] = useState(null);
  const [age, setAge] = React.useState("");
  const [Showdetail, setShowdetail] = useState(true);
  // const [values, setValues] = React.useState({
  //   textmask: "   -       ",
  //   numberformat: "1320",
  // });

  const [Pic, setPic] = useState(remy);
  const [ques, setques] = useState({
    ques1: ``,
    ques2: ``,
    ques3: ``,
    Id_ques: ``,
  });

  const [object, setobject] = useState({
    Id_ques: ``,
    group_id: ``,
    channel: ``,
    service: ``,
    product: ``,
    custype: ``,
    ques_sta: ``,
    bu: ``,
    admin: ``,
    B: `X`,
    send_bu: ``,
    detail: ``,
    phone: ``,
    phone: ``,
    customer_finance: ``,
  });

  const timer = React.useRef();

  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });
  ////////////////////////////////////select-data///////////////////////
  const [MultiList, setMultiList] = useState({
    channel: [`ช่องทาง`, `กลุ่ม O`, `กลุ่ม P4`, `กลุ่ม MR`],
    service: [
      `งานบริการ`,
      `สมัครงาน`,
      `ถามยอดชำระค่างวด`,
      `ชำระค่างวด`,
      `จัดไฟแนนซ์`,
      `ทะเบียนประกัน พรบ.`,
      `ขอหมายเลขบัญชีธนาคาร`,
      `ค่าปรับผิดนัดชำระ`,
      `เลื่อนค่างวด`,
      `ขอเบอร์โทรสาขา`,
      `ฝากประกาศขาย`,
      `ชื่นชมการบริการ`,
      `ร้องเรียนการบริการ`,
      `ยื่นขอประมูลรถ`,
      `แจ้งเปลี่ยนข้อมูลส่วนตัว`,
      `การหยืดหยุ่นการชำระหนี้`,
      `ใบเสร็จ`,
      `สมัครตัวแทนการตลาด`,
      `อื่นๆ`,
    ],
    product: [`ผลิตภัณฑ์`, `รถจักรยานยนต์`, `รถยนต์`, `ที่ดิน`, `อื่นๆ`],
    custype: [`ประเภทลูกค้า`, `เก่า`, `ใหม่`],
    ques_sta: [`สถานะงาน`, `ตามต่อ`, `แล้วเสร็จ`, `ส่งเรื่องให้สาขา`],
    send_bu: [
      `NAY`,
      `TKK`,
      `TYK`,
      `SOD`,
      `SKL`,
      `WNY`,
      `BRM`,
      `SUR`,
      `KBB`,
      `PCL`,
      `CHS`,
      `NKY`,
      `SRB`,
      `WAM`,
      `LBR`,
      `NKR`,
      `PYJ`,
      `SNR`,
      `NTR`,
      `RBR`,
      `KAN`,
      `PTY`,
      `RYL`,
      `PLD`,
      `STH`,
      `NOK`,
      `BUK`,
      `UDD`,
      `MDH`,
      `SKN`,
    ],
  });
  const [channel, setchannel] = useState([
    `ช่องทาง     `,
    `กลุ่ม O`,
    `กลุ่ม P4`,
    `กลุ่ม MR`,
  ]);
  const [Showbrance, setShowbrance] = useState(true);
  const [CHchannel, setCHchannel] = useState("");
  const [date, setdate] = useState("");
  React.useEffect(() => {
    const Liffin = async () => {
      var url = _interopDefault(require("url"));
      var urlParts = url.parse(window.location.href, true);
      var query = urlParts.query;
      setbrance(query.groupid);
      setobject({ ...object, group_id: query.groupid, bu: query.groupid });
      // var hasCodeProperty = Object.prototype.hasOwnProperty.call(query, "code");
      var idLiff = `1653921718-pmQEdR8W`;
      // alert(window.location.hostname)
      if (window.location.hostname === `pghejob.duckdns.org`) {
        idLiff = `1653921718-ql0vRr2a`;
      }
      clearTimeout(timer.current);
      await liff.init({ liffId: idLiff }).catch((err) => {
        throw err;
      });
      if (liff.isLoggedIn()) {
        let getProfile = await liff.getProfile();
        console.log(getProfile);
        setPic(getProfile.pictureUrl);

        //LIFF START//
        setdate(moment().format("DD-MM-YYYY HH:mm:ss"));
        var jsondata1 = {
          database: "CI_Docker_Social_Line",
          table: "Admin_Regis",
          query: { key: "line_id", query: getProfile.userId },
          path: "finder",
          port: "5003",
        };
        const MYSQL = await Kfunc.fetchlocal(jsondata1);
        console.log(MYSQL);
        if (MYSQL.length > 0) {
          setobject({ ...object, admin: MYSQL[0].employee_id });
          // alert("OK");
          var jsondata2 = {
            database: "CI_Docker_Social_Line",
            table: "Ques_Pgh_out",
            query: { key: "group_id", query: query.groupid },
            where: { key: "check_react", query: "false" },
            path: "finderwhere",
            port: "5003",
          };
          // jsondata1.table = "Ques_Pgh_out";
          // jsondata1.query.key = "group_id";
          // jsondata1.query.query = brance;
          // jsondata1.where.query = "false";
          const checkgroup = await Kfunc.fetchlocal(jsondata2);
          console.log(checkgroup);
          if (checkgroup.length > 0) {
            // alert("OK");
            checkgroup.unshift({
              Id_ques: "เลือก",
              ques1: "ไม่มี",
              ques2: "ไม่มี",
              ques3: "ไม่มี",
            });
            setpaylode(checkgroup);
            // setques({
            //   ...ques,
            //   ques1: checkgroup[0].ques1,
            //   ques2: checkgroup[0].ques2,
            //   ques3: checkgroup[0].ques3,
            // });
            setbutton(false);
          } else {
            alert("ไม่มีidกลุ่มในระบบ");
          }
        } else {
          alert("กรุณาสมัครadmin");
        }
      } else {
        liff.login({
          redirectUri: `https://lineadmin.prachakij.com/?groupid=${query.groupid}`,
        });
        // liff.login({ redirectUri: "https://crontap.duckdns.org/" });
      }
    };
    Liffin();
  }, []);

  React.useEffect(() => {
    if (object.service == "จัดไฟแนนซ์") {
      setMultiList({
        ...MultiList,
        ques_sta: [`สถานะงาน`, `ตามต่อ`, `ส่งเรื่องให้สาขา`],
      });
      setShowdetail(false);
    } else {
      setMultiList({
        ...MultiList,
        ques_sta: [`สถานะงาน`, `ตามต่อ`, `แล้วเสร็จ`, `ส่งเรื่องให้สาขา`],
      });
    }
  }, [object.service]);

  React.useEffect(() => {
    if (object.ques_sta == "ส่งเรื่องให้สาขา") {
      setShowbrance(false);
      setShowdetail(false);
      // setMultiList({ ...MultiList, ques_sta: [`สถานะงาน`, `ตามต่อ`,`ส่งเรื่องให้สาขา`]});
    } else {
      setShowbrance(true);
    }
    // else {
    //   setMultiList({
    //     ...MultiList,
    //     ques_sta: [`สถานะงาน`, `ตามต่อ`, `แล้วเสร็จ`, `ส่งเรื่องให้สาขา`],
    //   });
    // }
  }, [object.ques_sta]);

  const handleButtonClick2 = async () => {
    // var database = "BCT_AMS2_RPLC";
    // var table = "whatapp_token";
    // var query = { key: "token", query: "karantoekn" };
    var jsondata = {
      database: "PPP7",
      table: "PKGemployee",
      query: { key: "id", query: phone },
    };
    const check = await Kfunc.databass(jsondata);
    console.log(check);
    try {
      if (check[0].id) {
        console.log("ssssssssss");
        // alert(`${check[0].thprefix} ${check[0].name_th} ${check[0].surname_th}`)
        setFnameLname(
          `${check[0].thprefix} ${check[0].name_th} ${check[0].surname_th}`
        );
        setbrance(check[0].company_ctt);
        setpassword(false);
        setpaylode(check[0]);
        setbutton(false);
        // alert(check[0].line_id);
      }
    } catch (error) {
      setpassword(true);
      console.log("xxxxxxxxxxx");
    }
  };

  const handleButtonClick = async () => {
    if (!loading) {
      setSuccess(false);
      setLoading(true);
      timer.current = window.setTimeout(() => {
        setSuccess(true);
        setLoading(false);
      }, 2000);
    }
  };

  const lineliff = async () => {
    await liff.init({ liffId: `1653921718-pmQEdR8W` }).catch((err) => {
      throw err;
    });
    if (liff.isLoggedIn()) {
      let getProfile = await liff.getProfile();
      // console.log(getProfile);
      // this.setState({
      //   name: getProfile.displayName,
      //   userLineID: getProfile.userId,
      //   pictureUrl: getProfile.pictureUrl,
      // });
      const tim = new Date();
      // const timeo = date.addHours(tim, +7);
      var timeoutt = date.format(tim, "DD/MM/YYYY HH:mm:ss");
      var jsondata1 = {
        database: "CI_Docker_Social_Line",
        table: "Admin_Regis",
        query: { key: "line_id", query: getProfile.userId },
        path: "finder",
        port: "5003",
      };
      const MYSQL = await Kfunc.fetchlocal(jsondata1);
      console.log(MYSQL);
      if (MYSQL.length > 0) {
        // alert("OK");
        var jsondata2 = {
          database: "CI_Docker_Social_Line",
          table: "Ques_Pgh_out",
          query: { key: "group_id", query: brance },
          where: { key: "check_react", query: "false" },
          path: "finderwhere",
          port: "5003",
        };
        // jsondata1.table = "Ques_Pgh_out";
        // jsondata1.query.key = "group_id";
        // jsondata1.query.query = brance;
        // jsondata1.where.query = "false";
        const checkgroup = await Kfunc.fetchlocal(jsondata2);
        console.log(checkgroup);
        if (checkgroup.length > 0) {
          // alert("OK");
          checkgroup.unshift({
            Id_ques: "เลือก",
            ques1: "ไม่มี",
            ques2: "ไม่มี",
            ques3: "ไม่มี",
          });
          setpaylode(checkgroup);
          // setques({
          //   ...ques,
          //   ques1: checkgroup[0].ques1,
          //   ques2: checkgroup[0].ques2,
          //   ques3: checkgroup[0].ques3,
          // });
          setbutton(false);
        } else {
          alert("ไม่มีidกลุ่มในระบบ");
        }
      } else {
        alert("กรุณาสมัครadmin");
      }

      // const BCT = await Kfunc.fetchlocal(jsondata);
    } else {
      liff.login({
        redirectUri: `https://lineadmin.prachakij.com/?groupid=${brance}`,
      });
    }
  };

  var querystring = _interopDefault(require("querystring"));

  const select = (e) => {
    var jspare = JSON.parse(e.target.value);
    setobject({
      ...object,
      Id_ques: jspare.Id_ques,
      bu: jspare.bu,
    });
    setques({
      ...ques,
      ques1: jspare.ques1,
      ques2: jspare.ques2,
      ques3: jspare.ques3,
    });
    console.log(jspare.ques1);
    // alert(event.target.value.ques1)
  };

  function Spinner() {
    return (
      <img
        className="spinner"
        width="24"
        height="24"
        src="https://i.pinimg.com/originals/3e/f0/e6/3ef0e69f3c889c1307330c36a501eb12.gif"
      />
    );
  }
  function timeout(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function UserCreateButton() {
    const { startWaiting, endWaiting, isWaiting, Wait } = useWait();
    return (
      <Button
        type="submit"
        variant="contained"
        color="primary"
        className={buttonClassname}
        // disabled={loading}
        onClick={() => {
          var fun = async () => {
            await startWaiting("creating user");
            if (
              object.Id_ques == "" ||
              object.channel == `` ||
              object.service == `` ||
              object.product == `` ||
              object.custype == `` ||
              object.ques_sta == ``
            ) {
              alert(`กรอกข้อมูลให้ครับ`);
              endWaiting("creating user");
            } else if (object.service == "จัดไฟแนนซ์" && object.detail == "") {
              alert(`จัดไฟแนนซ์ ต้องใส่หมายเหตุและเบอร์โทร`);
              endWaiting("creating user");
            } else if (object.service == "จัดไฟแนนซ์" && object.phone == "") {
              alert(`จัดไฟแนนซ์ ต้องใส่เบอร์โทร`);
              endWaiting("creating user");
            } else {
              object.path = "endjob";
              object.port = "5004";
              /////////////////Mysql
              var ph = object.phone;
              var x;
              if (ph !== ``) {
                if (ph.indexOf("-") > -1) {
                  console.log("เบอร์ถูกต้อง");
                } else {
                  console.log("เบอร์แปลง");
                  x = ph
                    .replace(/\D+/g, "")
                    .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2$3");
                  console.log(x);
                  object.phone = x;
                }
              }
              let newvalues = [
                { key: "state", newvalues: object.channel },
                { key: "serve", newvalues: object.service },
                { key: "product", newvalues: object.product },
                { key: "custype", newvalues: object.custype },
                { key: "ques_sta", newvalues: object.ques_sta },
                { key: "admin", newvalues: object.admin },
                { key: "branch", newvalues: object.send_bu },
                { key: "neww", newvalues: object.detail },
                { key: "phone", newvalues: object.phone },
                { key: "update_chanel", newvalues: "lifeapp" },
                { key: "customer_finance", newvalues: object.customer_finance },
                { key: "check_react", newvalues: "true"}
              ];
              var jsondata1 = {
                database: "CI_Docker_Social_Line",
                table: "Ques_Pgh_out",
                query: { key: "Id_ques", query: object.Id_ques },
                newvalues: newvalues,
                path: "updater",
                port: "5003",
              };
              const MYSQL = await Kfunc.fetchlocal(jsondata1);
              // const UPDATE = await Kfunc.fetchlocal(object);
              // console.log(UPDATE);
              if (MYSQL.status == "UpdateSuccess") {
                alert(`update true`);
                window.location.reload();
              } else {
                alert(`update false`);
                endWaiting("creating user");
              }
            }
          };
          fun();
        }}
        disabled={isWaiting("creating user")}
      >
        <Wait on="creating user" fallback={<Spinner />}>
          ตกลง
        </Wait>
      </Button>
    );
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar alt="Remy Sharp" src={Pic} className={classes.large} />
        {/* <Typography component="h1" variant="h5">
          ระบบบันทึกงานบริการ
        </Typography> */}
        <List className={classes.root}>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <WorkIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="ระบบบันทึกงานบริการ AAM" secondary={date} />
          </ListItem>
          <Divider variant="inset" component="li" />
        </List>
        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            email: "",
            password: "",
          }}
          validationSchema={SignupSchema}
          onSubmit={(values) => {
            console.log(values);
          }}
        >
          {({ errors, handleChange, touched }) => (
            <Form className={classes.form}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  {button === false ? (
                    <FormControl className={classes.margin} fullWidth>
                      <InputLabel htmlFor="demo-customized-select-native">
                        คำถามลูกค้า.
                      </InputLabel>
                      <NativeSelect
                        id="demo-customized-select-native"
                        // value={ques.Id_ques}
                        onChange={select}
                        fullWidth
                        input={<BootstrapInput />}
                      >
                        {/* <option aria-label="None" value="" />
                      <option value={10}>Ten</option>
                      <option value={20}>Twenty</option>
                      <option value={30}>Thirกกกกกกกกกกกกกกกกกty</option> */}
                        {paylode.map((v) => (
                          <option
                            key={v.Id_ques}
                            name={v.Id_ques}
                            value={JSON.stringify(v)}
                          >
                            {v.create_time} {v.Id_ques.substring(0, 7)}
                          </option>
                        ))}
                      </NativeSelect>
                    </FormControl>
                  ) : null}
                </Grid>
                <Grid item xs={12}>
                  {button === false ? (
                    <TextField
                      disabled
                      id="filled-disabled"
                      label="คำถาม1"
                      value={ques.ques1}
                      variant="filled"
                      fullWidth
                      name="number"
                    />
                  ) : null}
                </Grid>
                <Grid item xs={12}>
                  {button === false ? (
                    <TextField
                      disabled
                      id="filled-disabled"
                      label="คำถาม2"
                      value={ques.ques2}
                      variant="filled"
                      fullWidth
                      name="number"
                    />
                  ) : null}
                </Grid>
                <Grid item xs={12}>
                  {button === false ? (
                    <TextField
                      disabled
                      id="filled-disabled"
                      label="คำถาม3"
                      value={ques.ques3}
                      variant="filled"
                      fullWidth
                      name="number"
                    />
                  ) : null}
                </Grid>
                <Grid item xs={12}>
                  {button === false ? (
                    <FormControl className={classes.margin} fullWidth>
                      {/* <InputLabel htmlFor="demo-customized-select-native">
                      คำถามลูกค้า
                    </InputLabel> */}
                      <NativeSelect
                        id="demo-customized-select-native"
                        // value={CHchannel}
                        onChange={(e) => {
                          setobject({
                            ...object,
                            channel: e.target.value,
                          });
                        }}
                        fullWidth
                        input={<BootstrapInput />}
                      >
                        {MultiList.channel.map((v) => (
                          <option key={v} name={v} value={v}>
                            {v}
                          </option>
                        ))}
                      </NativeSelect>
                    </FormControl>
                  ) : null}
                </Grid>
                <Grid item xs={12}>
                  {button === false ? (
                    <FormControl className={classes.margin} fullWidth>
                      {/* <InputLabel htmlFor="demo-customized-select-native">
                      คำถามลูกค้า
                    </InputLabel> */}
                      <NativeSelect
                        id="demo-customized-select-native"
                        // value={CHchannel}
                        onChange={(e) => {
                          setobject({
                            ...object,
                            service: e.target.value,
                          });
                        }}
                        fullWidth
                        input={<BootstrapInput />}
                      >
                        {MultiList.service.map((v) => (
                          <option key={v} name={v} value={v}>
                            {v}
                          </option>
                        ))}
                      </NativeSelect>
                    </FormControl>
                  ) : null}
                </Grid>
                <Grid item xs={12}>
                  {button === false ? (
                    <FormControl className={classes.margin} fullWidth>
                      {/* <InputLabel htmlFor="demo-customized-select-native">
                      คำถามลูกค้า
                    </InputLabel> */}
                      <NativeSelect
                        id="demo-customized-select-native"
                        // value={CHchannel}
                        onChange={(e) => {
                          setobject({
                            ...object,
                            product: e.target.value,
                          });
                        }}
                        fullWidth
                        input={<BootstrapInput />}
                      >
                        {MultiList.product.map((v) => (
                          <option key={v} name={v} value={v}>
                            {v}
                          </option>
                        ))}
                      </NativeSelect>
                    </FormControl>
                  ) : null}
                </Grid>
                <Grid item xs={12}>
                  {button === false ? (
                    <FormControl className={classes.margin} fullWidth>
                      {/* <InputLabel htmlFor="demo-customized-select-native">
                      คำถามลูกค้า
                    </InputLabel> */}
                      <NativeSelect
                        id="demo-customized-select-native"
                        // value={CHchannel}
                        onChange={(e) => {
                          setobject({
                            ...object,
                            custype: e.target.value,
                          });
                        }}
                        fullWidth
                        input={<BootstrapInput />}
                      >
                        {MultiList.custype.map((v) => (
                          <option key={v} name={v} value={v}>
                            {v}
                          </option>
                        ))}
                      </NativeSelect>
                    </FormControl>
                  ) : null}
                </Grid>
                <Grid item xs={12}>
                  {button === false ? (
                    <FormControl className={classes.margin} fullWidth>
                      {/* <InputLabel htmlFor="demo-customized-select-native">
                      คำถามลูกค้า
                    </InputLabel> */}
                      <NativeSelect
                        id="demo-customized-select-native"
                        // value={CHchannel}
                        onChange={(e) => {
                          setobject({
                            ...object,
                            ques_sta: e.target.value,
                          });
                        }}
                        fullWidth
                        input={<BootstrapInput />}
                      >
                        {MultiList.ques_sta.map((v) => (
                          <option key={v} name={v} value={v}>
                            {v}
                          </option>
                        ))}
                      </NativeSelect>
                    </FormControl>
                  ) : null}
                </Grid>
                <Grid item xs={12}>
                  {Showbrance === false ? (
                    <FormControl className={classes.margin} fullWidth>
                      {/* <InputLabel htmlFor="demo-customized-select-native">
                      คำถามลูกค้า
                    </InputLabel> */}
                      <NativeSelect
                        id="demo-customized-select-native"
                        // value={CHchannel}
                        onChange={(e) => {
                          setobject({
                            ...object,
                            send_bu: e.target.value,
                          });
                        }}
                        fullWidth
                        input={<BootstrapInput />}
                      >
                        {MultiList.send_bu.map((v) => (
                          <option key={v} name={v} value={v}>
                            {v}
                          </option>
                        ))}
                      </NativeSelect>
                    </FormControl>
                  ) : null}
                </Grid>
                <Grid item xs={12}>
                  {Showdetail === false ? (
                    <TextField
                      // error={phone === true}
                      variant="outlined"
                      fullWidth
                      onChange={(e) => {
                        e.preventDefault();
                        // s(e.target.value);
                        setobject({ ...object, phone: e.target.value });
                      }}
                      // name="number"
                      label="เบอร์โทร"
                      type="number"
                      id="outlined-error-helper-text"
                    />
                  ) : null}
                  {/* ) : null} */}
                </Grid>
                <Grid item xs={12}>
                  {Showdetail === false ? (
                    <TextField
                      // error={phone === true}
                      variant="outlined"
                      fullWidth
                      onChange={(e) => {
                        e.preventDefault();
                        // s(e.target.value);
                        setobject({
                          ...object,
                          customer_finance: e.target.value,
                        });
                      }}
                      // name="number"
                      label="ชื่อ-นามสกุล ลูกค้าสนใจจัดสินเชื่อ"
                      // type="number"
                      id="outlined-error-helper-text"
                    />
                  ) : null}
                  {/* ) : null} */}
                </Grid>
                <Grid item xs={12}>
                  {Showdetail === false ? (
                    <TextField
                      // error={phone === true}
                      variant="outlined"
                      fullWidth
                      onChange={(e) => {
                        e.preventDefault();
                        // s(e.target.value);
                        setobject({ ...object, detail: e.target.value });
                      }}
                      // name="number"
                      label="หมายเหตุ"
                      // type="number"
                      id="outlined-error-helper-text"
                    />
                  ) : null}
                  {/* ) : null} */}
                </Grid>
                {/* <Grid item xs={6}>
                  <TextField
                    error={Name === true}
                    variant="outlined"
                    fullWidth
                    onChange={(e) => {
                      e.preventDefault();
                      setName(e.target.value);
                    }}
                    name="number"
                    label="ชื่อ"
                    type="text"
                    id="outlined-error-helper-text"
                    // helperText="Incorrect entry."
                    autoComplete="fname"
                    helperText={Name === true ? "กรุณาใส่ ชื่อ" : null}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    error={FnameLname === true}
                    variant="outlined"
                    fullWidth
                    onChange={(e) => {
                      e.preventDefault();
                      setFnameLname(e.target.value);
                    }}
                    name="number"
                    label="นามสกุล"
                    type="text"
                    id="outlined-error-helper-text"
                    // helperText="Incorrect entry."
                    autoComplete="lname"
                    helperText={FnameLname === true ? "กรุณาใส่ นามสกุล" : null}
                  />
                </Grid>
              </Grid> */}
              </Grid>
              {button === false ? (
                <div className={classes.wrapper}>
                  <Waiter>
                    <UserCreateButton />
                  </Waiter>
                  {loading && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </div>
              ) : null}
              {Pic !== remy && button === true ? (
                <div className={classes.wrapper}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={buttonClassname}
                    disabled={loading}
                    onClick={(e) => {
                      e.preventDefault();
                      liff.logout();
                      setPic(remy);
                    }}
                  >
                    ออกจากระบบ
                  </Button>
                  {loading && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </div>
              ) : null}
            </Form>
          )}
        </Formik>
      </div>
    </Container>
  );
}
